export default "__VITE_ASSET__DNMPgY5A__"